import { Alert } from '@mui/material';
import React from 'react';

export function SubjectSearchAlert() {
  return (
    <Alert severity="info">Поиск организации работает по наименованию и ИНН.</Alert>
  );
}
